import { render, staticRenderFns } from "./RestrictionsExten.vue?vue&type=template&id=ef6a4fd0"
import script from "./RestrictionsExten.vue?vue&type=script&lang=ts"
export * from "./RestrictionsExten.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports